//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Associative",1,0],[0,"Characteristics",0,"Weld.CharacteristicsBuilder",0],[0,"ConnectedPartMethod",1,0],[1,"ConnectedPartTolerance",0,"Expression",0],[0,"DerivedDatum",1,0],[1,"Features",0,"SelectNXObjectList",0],[0,"MirrorPlane",1,"Plane",0],[0,"TranslateCsys",1,"CoordinateSystem",0],[1,"TranslateX",0,"Expression",0],[1,"TranslateY",0,"Expression",0],[1,"TranslateZ",0,"Expression",0],[0,"Type",1,0]],[],[]];
SPLM.Weld.TransformBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.TransformBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.TransformBuilder.TransformationTypes = Object.freeze({
    "Mirror" : "Mirror", "Translate" : "Translate"});

SPLM.Weld.TransformBuilder.ConnectedPartMethods = Object.freeze({
    "TransformBody" : "TransformBody", "ParentFaces" : "ParentFaces"});

export default SPLM;